import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { preloadEditorAssets } from './utils/assetPreloader';

const params = new URLSearchParams(window.location.search);
const mode = params.get('mode');

// Start downloading all canvas assets NOW — in parallel with the App chunk
// and the INIT_EDITOR handshake (no-op when the URL params are absent).
preloadEditorAssets();

async function boot() {
  const pinia = createPinia();
  if (mode === 'form-builder') {
    const { default: FormBuilderApp } = await import('./components/forms/FormBuilderApp.vue');
    const app = createApp(FormBuilderApp);
    app.use(pinia);
    app.mount('#vue3-editor-app');
    console.log('[Vue 3 Editor] Form builder initialized');
    return;
  }
  const { default: App } = await import('./App.vue');
  const app = createApp(App);
  app.use(pinia);
  app.mount('#vue3-editor-app');
  console.log('[Vue 3 Editor] Initialized');
}

boot();
